import React, {useState, useEffect} from 'react';

function ClientViewPageSettingsButtonMapping() {
    const [bindedKey, setBindedKey] = useState(null)
    const [isBinding, setIsBinding] = useState(false)

    const [showAlertERROR, setShowAlertERROR] = useState(false)
    const [ERRORAlertText, setERRORAlertText] = useState("")

    const showAlert = (type, text) => {
        if (type === "error") {
            setShowAlertERROR(true)
            setERRORAlertText(text)

            setTimeout(function() {
                setShowAlertERROR(false)
            }, 3500)
        }
    }

    const handleBindKey = async () => {
        setIsBinding(true)
        const response = await window.pywebview.api.bind_key();

        if (response.status === "success") {
            setBindedKey(response["key-value"])
        } else {
            showAlert("error", response.message)
        }

        setIsBinding(false)
    }

    useEffect(() => {
        async function fetchBindendKey() {
            const binded_key = await window.pywebview.api.get_bindend_key();

            if (binded_key !== -1) {
                setBindedKey(binded_key)
            }
        }

        fetchBindendKey()
    }, [])

    return (
        <>
            <div className="flex flex-col gap-4 md:gap-0 md:flex-row items-center justify-between p-4 bg-[#101922] border border-[#324d67] rounded-lg">
                <div>
                    <p className="text-white font-medium">Change HUD</p>
                    <p className="text-[#92adc9] text-xs">Switch from the main display to the secondary one.</p>
                </div>

                <button onClick={() => handleBindKey()} className="bg-primary hover:bg-primary/80 text-white text-sm font-bold px-6 py-2 rounded-lg transition-all flex items-center gap-2">
                    {isBinding ? (
                        <span>You may press the button...</span>
                    ) : bindedKey !== null ? (
                        <span>Button-{bindedKey}</span>
                    ) : (
                        <>
                            <span className="material-symbols-outlined text-[18px]">add</span>
                            Bind Button
                        </>
                    )}
                </button>
            </div>

            {showAlertERROR && <span className="flex px-5 py-2 rounded-xl fixed z-[999] bg-alert-red text-sm right-[10px] top-[35px] select-none animate-[show-alert_3s_ease-in-out_forwards]">{ERRORAlertText}</span>}
        </>
    );
}


export default ClientViewPageSettingsButtonMapping;